const mfaAndResetActivationCodeEntryTemplate = `
<!--todo: this should be a directive-->
<div data-ng-show="verificationMessage !== null" class="form-group has-error">
    <span class="help-block">{{verificationMessage}}</span>
</div>

<div data-ng-show="mfa.errorMessage !='' && mfa.errorMessage !=null && mfa.errorMessage!='undefined'"
    class="form-group has-error">
    <span class="help-block" translate="{{mfa.errorMessage}}"
        translate-default="We are unable to send verification codes at this time. Please try again. Contact a Participant Services Representative if the problem continues."></span>
</div>

<a href="#" ng-if="displayFieldError('verificationCode');" id="screenReader" class="sr-only"
    ng-click="focusOnErrorInput($event, 'verification_codeInput')">
    <ng-messages for="getFieldError('verificationCode');" ng-if="displayFieldError('verificationCode');"
        class="form-group has-error">
        <ng-message when="required">{{"verificationcodeRequired" | translate }}</ng-message>
    </ng-messages>, Focus invalid input.
</a>

<div class="form-group" data-ng-class="getFormGroupClass('verificationCode');">
    <label for="verification_codeInput" class="control-label">{{"pleaseEnterCode" | translate}}</label>
    <input type="tel" class="form-control" id="verification_codeInput" name="verificationCode" auto-focus
        data-ng-required="true" data-activationcode-validator data-mask="99999999" data-mask-restrict="accept"
        data-mask-clean="true" maxlength="8" data-ng-model="verification.verificationCode"
        data-ng-model-options="{ updateOn: 'blur', allowInvalid: true }" ng-blur="activationCodeChange()" />
    <ng-messages for="getFieldError('verificationCode');" ng-if="displayFieldError('verificationCode');"
        class="form-group has-error">
        <ng-message when="required">{{"verificationcodeRequired" | translate }}</ng-message>
    </ng-messages>
</div>
`;
export default mfaAndResetActivationCodeEntryTemplate;